
import React from 'react';
import { Minus, Plus } from 'lucide-react';
import { Button } from '../../../../../components/ui/button';
import { Input } from '../../../../../components/ui/input';
import { BaseFieldPreviewProps, handleAddOption, handleRemoveOption, handleOptionLabelChange } from './previewUtils';

const SelectFieldPreview: React.FC<BaseFieldPreviewProps> = ({ field, renderDescription, onUpdateOptions }) => {
  if (!field.options) return null;

  return (
    <div>
      {renderDescription()}

      <div className="space-y-2 mt-2 border border-gray-200 rounded-md p-2">
        {field.options.map((option: string, index: number) => (
          <div key={`option-${index}`} className="flex items-center gap-2">
            <div className="text-sm text-gray-500 w-6">{index + 1}.</div>
            <Input
              value={option}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => onUpdateOptions && handleOptionLabelChange(index, e.target.value, field.options || [], onUpdateOptions)}
              className="flex-1"
            />
            <Button
              variant="ghost"
              size="sm"
              disabled={field.options?.length <= 2}
              onClick={() => onUpdateOptions && handleRemoveOption(index, field.options || [], onUpdateOptions)}
              className="p-0 h-8 w-8"
            >
              <Minus className="h-4 w-4" />
            </Button>
          </div>
        ))}

        <div className="flex items-center gap-2 mt-2">
          <div className="text-sm text-gray-500 w-6">{field.options.length + 1}.</div>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onUpdateOptions && handleAddOption(field.options || [], onUpdateOptions)}
            className="w-full flex items-center justify-start text-gray-500 h-10"
          >
            <Plus className="h-4 w-4 mr-2" />
            Option hinzufügen
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SelectFieldPreview;
